import { apiGet, apiFetch } from "../api-client"

export interface AppNotification {
  id: string
  verb: string
  message: string
  notif_type: "info" | "success" | "warning" | "error"
  action_url: string
  read: boolean
  read_at: string | null
  created_at: string
}

export interface NotificationListResponse {
  count: number
  next: string | null
  previous: string | null
  results: AppNotification[]
}

/**
 * Fetch paginated notifications for the current user
 */
export async function fetchNotifications(): Promise<NotificationListResponse> {
  return apiGet<NotificationListResponse>("/api/notifications/")
}

/**
 * Fetch the unread notification count badge value
 */
export async function fetchUnreadCount(): Promise<{ count: number }> {
  return apiGet<{ count: number }>("/api/notifications/unread-count/")
}

/**
 * Mark a single notification as read
 */
export async function markNotificationRead(id: string): Promise<void> {
  const response = await apiFetch(`/api/notifications/${id}/read/`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: "Request failed" }))
    throw new Error(error.detail || `Request failed with status ${response.status}`)
  }
}

/**
 * Mark all notifications as read for the current user
 */
export async function markAllRead(): Promise<void> {
  const response = await apiFetch("/api/notifications/read-all/", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  })
  if (!response.ok) {
    const error = await response.json().catch(() => ({ detail: "Request failed" }))
    throw new Error(error.detail || `Request failed with status ${response.status}`)
  }
}
